import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { errMsg } from '../lib/api';
import { useToast } from '../hooks/use-toast';
import { safePaymentReturn, afterPaymentLogin } from '../lib/paymentReturn';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const { toast } = useToast();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    const target = safePaymentReturn(window.location.pathname);
    window.history.replaceState(null, '', window.location.pathname);
    completeGoogle(sessionId)
      .then(account => navigate(afterPaymentLogin(account, target), { replace: true }))
      .catch(e => { toast({ title: 'Google sign-in failed', description: errMsg(e), variant: 'destructive' }); navigate(target ? `/login?next=${encodeURIComponent(target)}` : '/login', { replace: true }); });
  }, [completeGoogle, location.hash, navigate, toast]);

  return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 text-sm" data-testid="auth-callback">Signing you in…</div>;
}
